var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteSmsInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UX-429-Invite-User-Via-Sms-Dialpad-VidyoConnect-Desktop-v7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B01",
    transform: "translate(-455.000000, -482.000000)",
    fill: "#B4C3D0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invite",
    transform: "translate(420.000000, 238.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tabs",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53,204 C54.1,204 55,204.9 55,206 L55,206 L55,218 C55,219.1 54.1,220 53,220 L53,220 L39,220 L35,224 L35,206 C35,204.9 35.9,204 37,204 L37,204 Z M41,211 C40.4477153,211 40,211.447715 40,212 C40,212.552285 40.4477153,213 41,213 C41.5522847,213 42,212.552285 42,212 C42,211.447715 41.5522847,211 41,211 Z M45,211 C44.4477153,211 44,211.447715 44,212 C44,212.552285 44.4477153,213 45,213 C45.5522847,213 46,212.552285 46,212 C46,211.447715 45.5522847,211 45,211 Z M49,211 C48.4477153,211 48,211.447715 48,212 C48,212.552285 48.4477153,213 49,213 C49.5522847,213 50,212.552285 50,212 C50,211.447715 49.5522847,211 49,211 Z",
    id: "Shape-Copy"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSmsInactive);
export default __webpack_public_path__ + "static/media/invite_sms_inactive.fe647b123b0865322e9afe557e1b0421.svg";
export { ForwardRef as ReactComponent };